<template>
  <div>
    <!-- Core Application -->
    <div v-if="!forgotPassword">
      <!-- Non column Based -->
      <TopNav/>
      <LeftMobileMenu/>
      <RightMobileMenu :fullScreenMode="fullScreenMode"/>
      <!-- Modals -->
      <ProductDetail :key="$route.fullPath"/>
      <ShipToSelectorModal v-if="!internalRoles.includes(user.role)"/>
      <PrepaidExclude/>
      <FeedBackModal/>
      <BetaModal/>
      <FavViewModal/>
      <CartCopyMoveModal/>
      <CrossSellModal/>
      <VideoModal/>
      <DropshipPolicyModal/>
      <DropshipLineDisabledModal/>
      <!-- <PrepaidFreightUpdateModal/> -->
      <div class="row">
        <!-- Left Column -->
        <div
          ref="leftSide"
          class="col-lg-2 d-none d-lg-block left-side p-0"
          v-if="!fullScreenMode"
          :style="adminMode ? {'height': `100vh`, 'background': 'var(--bs-primary)'} : {'height': bodyHeight, 'background' : 'white'}">
          <LeftSide/>
        </div>
        <!-- Middle Column -->
        <div
          class="col-12 p-0"
          :class="fullScreenMode ? 'col-lg-12' : 'col-lg-10'">
          <Content :adminMode="adminMode"/>
          <BottomNav
            ref="bottomNav"
            class="bottom-nav"/>
        </div>
      </div>
    </div>
    <MobileFilterControls/>
    <!-- Set New Password if gone through forgort password avenue - Cant Continue until completed -->
    <SetNewPassword v-if="forgotPassword"/>
  </div>
</template>

<script>
  import Content from './Content.vue'
  import LeftSide from '../menus/desktop/LeftSide.vue'
  import RightSide from '../menus/desktop/RightSide.vue'
  import TopNav from '../nav/TopNav.vue'
  import BottomNav from '../nav/BottomNav.vue'
  import RightMobileMenu from '../menus/mobile/RightMobileMenu.vue'
  import LeftMobileMenu from '../menus/mobile/LeftMobileMenu.vue'
  import BetaModal from './BetaModal.vue'
  import SetNewPassword from './SetNewPassword.vue'
  import CartCopyMoveModal from './cartCopyMove/CartCopyMoveModal.vue'
  import MobileFilterControls from '../menus/mobile/filters/MobileFilterControls.vue'

  // Modals
  import ProductDetail from '../views/product/detail/ProductDetail.vue'
  import ShipToSelectorModal from './ShipToSelectorModal.vue'
  import PrepaidExclude from '../views/product/PrepaidExclude.vue'
  import FeedBackModal from '../app/FeedBackModal.vue'
  import FavViewModal from '../app/FavViewModal.vue'
  import VideoModal from './VideoModal.vue'
  import CrossSellModal from './CrossSellModal.vue'
  import DropshipLineDisabledModal from './DropshipLineDisabledModal.vue'
  
  import {internalRoles} from '../../../shared/roles'
  import DropshipPolicyModal from './DropshipPolicyModal.vue'
  import PrepaidFreightUpdateModal from './PrepaidFreightUpdateModal.vue'


  export default{
    data(){
      return{
        internalRoles,
        bodyHeight: null
      }
    },
    created(){
      this.$store.dispatch('freightAmounts')
    },
    mounted(){
      this.calcBodyHeight()
      window.addEventListener('resize', function(){
       this.calcBodyHeight()
      }.bind(this))
    },
    components:{
      Content,
      LeftSide,
      RightSide,
      TopNav,
      BottomNav,
      RightMobileMenu,
      LeftMobileMenu,
      ProductDetail,
      ShipToSelectorModal,
      PrepaidExclude,
      FeedBackModal,
      BetaModal,
      FavViewModal,
      SetNewPassword,
      CartCopyMoveModal,
      VideoModal,
      CrossSellModal,
      MobileFilterControls,
      DropshipPolicyModal,
      DropshipLineDisabledModal,
      PrepaidFreightUpdateModal
    },
    methods:{
      calcBodyHeight(){
        const topNav = document.getElementById('topNav').clientHeight
        this.bodyHeight = (window.innerHeight - topNav) + 'px'
      }
    },
    computed:{
      showSideBar(){return this.$store.getters.showSideBar},
      showLeftMenu(){return this.$store.getters.showLeftMenu},
      showRightMenu(){return this.$store.getters.showRightMenu},
      adminMode(){return this.$router.currentRoute.value.path == '/admin'},
      fullScreenMode(){return ['/virtual_show', '/dropship_hub'].includes(this.$router.currentRoute.value.path)},
      user(){return this.$store.getters.user},
      forgotPassword(){return this.$store.getters.forgotPassword}
    }
  }
</script>

<style scoped>
  @media(min-width: 992px){
    .bottom-nav{
      display:none;
    }
  }
  .left-side{
    overflow-y: scroll;
  }
  /* .left-side::-webkit-scrollbar {
    display: none;
  } */

/* Hide scrollbar for IE, Edge and Firefox */

</style>
